export default "__VITE_ASSET__B4P1FK2x__"